module.exports = __webpack_public_path__ + "assets/img/Cumulative_tasks_title.24637c31.png";